import img1 from "../assets/gallery/Russia/russia1.jpg";
import img2 from "../assets/gallery/Russia/russia2.jpg";
import img3 from "../assets/gallery/Russia/russia3.jpg";
import img4 from "../assets/gallery/Russia/russia4.jpg";
import img5 from "../assets/gallery/Russia/russia5.jpg";
import img6 from "../assets/gallery/Russia/russia6.jpg";
import img7 from "../assets/gallery/Russia/russia7.jpg";
import img8 from "../assets/gallery/Russia/russia8.jpg";
import img9 from "../assets/gallery/Russia/russia9.jpg";
import img10 from "../assets/gallery/Russia/russia10.jpg";
import img11 from "../assets/gallery/Russia/russia11.jpg";
import img12 from "../assets/gallery/Russia/russia12.jpg";
import img13 from "../assets/gallery/Russia/russia13.jpg";
import img14 from "../assets/gallery/Russia/russia14.jpg";
import img15 from "../assets/gallery/Russia/russia15.jpg";
import img16 from "../assets/gallery/Russia/russia16.jpg";
import img17 from "../assets/gallery/Russia/russia17.jpg";
import img18 from "../assets/gallery/Russia/russia18.jpg";
import img19 from "../assets/gallery/Russia/russia19.jpg";
import img20 from "../assets/gallery/Russia/russia20.jpg";
import img21 from "../assets/gallery/Russia/russia21.jpg";
import img22 from "../assets/gallery/Russia/russia22.jpg";
import img23 from "../assets/gallery/Russia/russia23.jpg";
import img24 from "../assets/gallery/Russia/russia24.jpg";
import img25 from "../assets/gallery/Russia/russia25.jpg";
import img26 from "../assets/gallery/Russia/russia26.jpg";
import img27 from "../assets/gallery/Russia/russia27.jpg";
import img28 from "../assets/gallery/Russia/russia28.jpg";
import img29 from "../assets/gallery/Russia/russia29.jpg";
import img30 from "../assets/gallery/Russia/russia30.jpg";

const russiaGallery = [
  { img: img1, colSpan: 2, rowSpan: 2 }, // featured
  { img: img2 },
  { img: img3 },
  { img: img4 },

  { img: img5 },
  { img: img6 },
  { img: img7, rowSpan: 2 },
  { img: img8 },
  { img: img9, colSpan: 2 },

  { img: img10 },
  { img: img11 },
  { img: img12 },
  { img: img13, colSpan: 2 },
  { img: img14 },

  { img: img15, rowSpan: 2 },
  { img: img16 },
  { img: img17 },
  { img: img18, colSpan: 2 },

  { img: img19 },
  { img: img20 },
  { img: img21, rowSpan: 2 },
  { img: img22 },

  { img: img23, colSpan: 2 },
  { img: img24 },
  { img: img25 },
  { img: img26 },

  { img: img27, rowSpan: 2 },
  { img: img28 },
  { img: img29, colSpan: 2 },
  { img: img30 },
];

export default russiaGallery;
